import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultTitle: {
    id: 'personAgendaBlock.defaultTitle',
    defaultMessage: 'Events Calendar',
  },
  filterLabel: {
    id: 'personAgendaBlock.filterLabel',
    defaultMessage: 'Filters',
  },
  searchLabel: {
    id: 'personAgendaBlock.searchLabel',
    defaultMessage: 'Search events',
  },
  searchPlaceholder: {
    id: 'personAgendaBlock.searchPlaceholder',
    defaultMessage: 'Search by title, description or location',
  },
  downloadAgenda: {
    id: 'personAgendaBlock.downloadAgenda',
    defaultMessage: 'Download',
  },
  downloadAgendaPlaceholder: {
    id: 'personAgendaBlock.downloadAgendaPlaceholder',
    defaultMessage: 'Agenda download will be available soon',
  },
  today: {
    id: 'personAgendaBlock.today',
    defaultMessage: 'Today',
  },
  monthView: {
    id: 'personAgendaBlock.monthView',
    defaultMessage: 'Month',
  },
  listView: {
    id: 'personAgendaBlock.listView',
    defaultMessage: 'Event List',
  },
  weekView: {
    id: 'personAgendaBlock.weekView',
    defaultMessage: 'Week',
  },
  dayView: {
    id: 'personAgendaBlock.dayView',
    defaultMessage: 'Day',
  },
  noEvents: {
    id: 'personAgendaBlock.noEvents',
    defaultMessage: 'No events found for the current filters.',
  },
  loading: {
    id: 'personAgendaBlock.loading',
    defaultMessage: 'Loading calendar events...',
  },
  loadError: {
    id: 'personAgendaBlock.loadError',
    defaultMessage: 'Unable to load the configured calendar.',
  },
  visualization: {
    id: 'personAgendaBlock.visualization',
    defaultMessage: 'View:',
  },
  eventType: {
    id: 'personAgendaBlock.eventType',
    defaultMessage: 'Event Type',
  },
  periodLabel: {
    id: 'personAgendaBlock.periodLabel',
    defaultMessage: 'Period',
  },
  periodToday: {
    id: 'personAgendaBlock.periodToday',
    defaultMessage: 'Today',
  },
  periodLast7Days: {
    id: 'personAgendaBlock.periodLast7Days',
    defaultMessage: 'Last 7 days',
  },
  periodNextMonth: {
    id: 'personAgendaBlock.periodNextMonth',
    defaultMessage: 'Next month',
  },
  periodPreviousMonth: {
    id: 'personAgendaBlock.periodPreviousMonth',
    defaultMessage: 'Previous month',
  },
  periodLast6Months: {
    id: 'personAgendaBlock.periodLast6Months',
    defaultMessage: 'Last 6 months',
  },
  dateRangeLabel: {
    id: 'personAgendaBlock.dateRangeLabel',
    defaultMessage: 'Filter by date',
  },
  fromDate: {
    id: 'personAgendaBlock.fromDate',
    defaultMessage: 'From',
  },
  toDate: {
    id: 'personAgendaBlock.toDate',
    defaultMessage: 'To',
  },
  // activeFilters: {
  //   id: 'personAgendaBlock.activeFilters',
  //   defaultMessage: 'Active filters',
  // },
  clearFilters: {
    id: 'personAgendaBlock.clearFilters',
    defaultMessage: 'Clear filters',
  },
  close: {
    id: 'personAgendaBlock.close',
    defaultMessage: 'Close',
  },
  closeDetails: {
    id: 'personAgendaBlock.closeDetails',
    defaultMessage: 'Close event details',
  },
  viewEvent: {
    id: 'personAgendaBlock.viewEvent',
    defaultMessage: 'View event',
  },
  allDay: {
    id: 'personAgendaBlock.allDay',
    defaultMessage: 'All day',
  },
  // currentEvents: {
  //   id: 'personAgendaBlock.currentEvents',
  //   defaultMessage: 'visible events',
  // },
  sourceFallback: {
    id: 'personAgendaBlock.sourceFallback',
    defaultMessage: 'Linked calendar',
  },
  calendarMode: {
    id: 'personAgendaBlock.calendarMode',
    defaultMessage: 'Calendar',
  },
  filterToggleOpen: {
    id: 'personAgendaBlock.filterToggleOpen',
    defaultMessage: 'Open filters',
  },
  filterToggleClose: {
    id: 'personAgendaBlock.filterToggleClose',
    defaultMessage: 'Close filters',
  },
  previousPeriod: {
    id: 'personAgendaBlock.previousPeriod',
    defaultMessage: 'Previous period',
  },
  nextPeriod: {
    id: 'personAgendaBlock.nextPeriod',
    defaultMessage: 'Next period',
  },
  // categoriesCount: {
  //   id: 'personAgendaBlock.categoriesCount',
  //   defaultMessage: '{count} categories',
  // },
  // eventsCount: {
  //   id: 'personAgendaBlock.eventsCount',
  //   defaultMessage: '{count} events',
  // },
  monthEventsCount: {
    id: 'personAgendaBlock.monthEventsCount',
    defaultMessage: '{count} events',
  },
  expandAllMonths: {
    id: 'personAgendaBlock.expandAllMonths',
    defaultMessage: 'Expand all',
  },
  collapseAllMonths: {
    id: 'personAgendaBlock.collapseAllMonths',
    defaultMessage: 'Collapse all',
  },
  untitledEvent: {
    id: 'personAgendaBlock.untitledEvent',
    defaultMessage: 'Untitled event',
  },
  weekOfRange: {
    id: 'personAgendaBlock.weekOfRange',
    defaultMessage: 'Week of {start} to {end}',
  },
  currentContext: {
    id: 'personAgendaBlock.currentContext',
    defaultMessage: 'Current context:',
  },
  exportCsvButton: {
    id: 'Download CSV',
    defaultMessage: 'Download CSV',
  },
  exportModalTitle: {
    id: 'Download calendar',
    defaultMessage: 'Download calendar',
  },
  exportModalDescription: {
    id: 'Select a required date range to export. The maximum interval is one year.',
    defaultMessage:
      'Select a required date range to export. The maximum interval is one year.',
  },
  exportConfirm: {
    id: 'Generate CSV',
    defaultMessage: 'Generate CSV',
  },
  exportCancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel',
  },
  exportGenerating: {
    id: 'Generating..',
    defaultMessage: 'Generating...',
  },
  exportDateRequired: {
    id: 'Start and end dates are required.',
    defaultMessage: 'Start and end dates are required.',
  },
  exportDateInvalid: {
    id: 'Please provide a valid date range.',
    defaultMessage: 'Please provide a valid date range.',
  },
  exportDateOrderError: {
    id: 'End date must be the same or after start date.',
    defaultMessage: 'End date must be the same or after start date.',
  },
  exportDateMaxRange: {
    id: 'The maximum export period is one year.',
    defaultMessage: 'The maximum export period is one year.',
  },
  exportNoResults: {
    id: 'No events found for the selected period.',
    defaultMessage: 'No events found for the selected period.',
  },
  exportGenericError: {
    id: 'Unable to generate CSV at this time.',
    defaultMessage: 'Unable to generate CSV at this time.',
  },
});

export const compromissoTypeMessages = defineMessages({
  leave: {
    id: 'personAgendaBlock.compromissoType.leave',
    defaultMessage: 'Leave',
  },
  hearing: {
    id: 'personAgendaBlock.compromissoType.hearing',
    defaultMessage: 'Hearing',
  },
  public_hearing: {
    id: 'personAgendaBlock.compromissoType.public_hearing',
    defaultMessage: 'Public hearing',
  },
  event: {
    id: 'personAgendaBlock.compromissoType.event',
    defaultMessage: 'Event',
  },
  gifts_hospitalities: {
    id: 'personAgendaBlock.compromissoType.gifts_hospitalities',
    defaultMessage: 'Gifts and hospitalities',
  },
  meeting: {
    id: 'personAgendaBlock.compromissoType.meeting',
    defaultMessage: 'Meeting',
  },
  substituting: {
    id: 'personAgendaBlock.compromissoType.substituting',
    defaultMessage: 'Substituting',
  },
  travel_private_expenses: {
    id: 'personAgendaBlock.compromissoType.travel_private_expenses',
    defaultMessage: 'Travel - Private expenses',
  },
  travel_scdp: {
    id: 'personAgendaBlock.compromissoType.travel_scdp',
    defaultMessage: 'Travel - SCDP',
  },
  despacho: {
    id: 'personAgendaBlock.compromissoType.despacho',
    defaultMessage: 'Dispatch',
  },
  viagem: {
    id: 'personAgendaBlock.compromissoType.viagem',
    defaultMessage: 'Travel',
  },
  'missao-tecnica': {
    id: 'personAgendaBlock.compromissoType.missao_tecnica',
    defaultMessage: 'Technical mission',
  },
  coletiva: {
    id: 'personAgendaBlock.compromissoType.coletiva',
    defaultMessage: 'Press conference',
  },
  seminario: {
    id: 'personAgendaBlock.compromissoType.seminario',
    defaultMessage: 'Seminar',
  },
  outros: {
    id: 'personAgendaBlock.compromissoType.outros',
    defaultMessage: 'Others',
  },
});

export const getInitialMode = (initialView) => {
  return initialView === 'list' ? 'list' : 'calendar';
};

export const getInitialCalendarView = (initialView) => {
  if (['month', 'week', 'day'].includes(initialView)) {
    return initialView;
  }

  return 'month';
};

/**
 * Retorna o label traduzido do tipo de compromisso/evento.
 * @param {string} category - chave do tipo de compromisso
 * @param {object} intl - objeto intl do react-intl
 * @param {string} [fallback] - texto alternativo caso não exista tradução
 * @returns {string}
 */
export function getCompromissoTypeLabel(category, intl, fallback = null) {
  if (!category || !intl) return fallback || category;
  if (compromissoTypeMessages[category]) {
    return intl.formatMessage(compromissoTypeMessages[category]);
  }
  return fallback || category;
}
